import * as React from "react";
import {
  Box,
  Collapse,
  IconButton,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";

function LanguageDropdown() {
  const [open, setOpen] = React.useState(false);
  const dropdownRef = React.useRef(null);

  // Handle click inside
  const handleClick = () => {
    setOpen(!open);
  };

  // Handle click outside
  React.useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <Box
      ref={dropdownRef}
      sx={{
        display: "flex",
        justifyContent: "end",
        alignItems: "end",
        flexDirection: "column",
        position: "relative",
      }}
    >
      {/* Dropdown Toggle Button */}
      <IconButton
        onClick={handleClick}
        sx={{
          p: "0px",
          transform: open ? "rotate(90deg)" : "rotate(0deg)",
          transition: "transform .3s ease-in-out",
        }}
      >
        <EastIcon sx={{ color: "#000000" }} />
      </IconButton>
      {/* Collapsible Dropdown Menu */}
      <Collapse
        in={open}
        timeout="auto"
        sx={{
          pt: open ? "10px" : "",
          pr: "22px",
          width: "445px",
        }}
      >
        <List
          sx={{
            border: "1px solid #DCDCDC",
            borderRadius: "16px",
            boxShadow: "none",
            backgroundColor: "#fff",
            p: "10px",
            width: "100%",
          }}
        >
          {["English", "Hindi", "Urdu", "Turkish"].map((language) => (
            <ListItem
              key={language}
              button
              onClick={() => setOpen(false)} // Close dropdown when selecting a language
              sx={{
                cursor: "pointer",
                color: "#12121299",
                fontFamily: "Inter",
                "&:hover": {
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                },
              }}
            >
              <Typography>{language}</Typography>
            </ListItem>
          ))}
        </List>
      </Collapse>
    </Box>
  );
}

export default LanguageDropdown;
